module.exports = __webpack_public_path__ + "img/aej1n-66wvl.023.7e8210bd.png";